// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"7aa20d4d","453":"f4172f4d","455":"5ac874b1","977":"3563a008"}[chunkId] + ".chunk.js";
};